module.exports = __webpack_public_path__ + "img/banner_1.421e5b54.png";